export default __webpack_public_path__ + "static/media/rami-hod.baf114d8.png";